import React, { useContext, useEffect, useState } from "react";
import { DContext } from "../../../context/Datacontext";
import { TbArrowNarrowRight } from "react-icons/tb";

export const ExploreCourse = () => {
    const {BeURL} = useContext(DContext)
    const [courses, setCourses] = useState([])
    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const res = await fetch(`${BeURL}/explore-courses`)
                const data = await res.json()
                if (data.success) {
                    setCourses(data.courses)
                }
            } catch (err) {
                console.log("Error fetching courses", err)
            }
        }
        fetchCourses()
    }, [BeURL])

    return (
        <section className="py-14 overflow-hidden bg-primary-50">
            <div className="w-full max-w-7xl mx-auto px-4 overflow-x-hidden">

                <h1 className="text-primary-800 text-[24px] sm:text-[35px] md:text-[45px] font-bold text-center">
                    Explore Courses
                </h1>

                <p className="mt-3 text-center max-w-4xl mx-auto text-lg">
                    Discover a comprehensive range of professionally curated courses designed to enhance your expertise and career growth.
                </p>

                <div className="relative mt-10 mb-10">

                    <div className="flex gap-6 animate-scroll hover:[animation-play-state:paused]">

                        {[...courses, ...courses].map((course, index) => (
                            <div
                                key={index}
                                className="w-[300px] shrink-0 border p-4 rounded-xl shadow-md group transition duration-300 hover:border-primary-600 hover:bg-primary-100 bg-white"
                            >

                                <img
                                    src={`${BeURL}${course?.thumbnail?.url}`}
                                    alt={course.title}
                                    className="h-[200px] w-full object-cover rounded-md mb-3"
                                />

                                <p className="text-primary-600 text-center text-[18px] font-semibold mb-2">
                                    {course.title}
                                </p>

                                <p className="text-gray-600 text-center text-[14px] mb-4">
                                    {course.description?.slice(0, 80)}...
                                </p>

                                {/* <button className="w-full border p-2 rounded-lg border-[#2B5AA0] text-[#2B5AA0] font-semibold group-hover:bg-primary-600 group-hover:text-white transition">
                                    Explore Program
                                </button> */}
                            </div>
                        ))}

                    </div>
                </div>

                <div className="flex justify-center items-center gap-2 cursor-pointer">
                    <button onClick={()=>window.location.href='/courses'} className="text-primary-600 font-bold flex items-center gap-2 group">
                        Explore all courses
                        <TbArrowNarrowRight className="transition-transform duration-300 group-hover:translate-x-2" />
                    </button>
                </div>
            </div>
        </section>
    );
};